import React, { useState } from 'react';
import './Hero.css';
import logo from '../assets/logo.png';
import api from '../services/api';

export default function HeroWithNavbar() {
  const [awbNumber, setAwbNumber] = useState('');
  const [trackingData, setTrackingData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleAWBSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setTrackingData([]);
    setLoading(true);

    try {
      const res = await api.post(`/tracking/awb/${awbNumber}`);
      // Sort tracking data by tracking_time descending
      const sorted = res.data.sort((a, b) => new Date(b.tracking_time) - new Date(a.tracking_time));
      setTrackingData(sorted);
    } catch (err) {
      console.error('Error fetching tracking data:', err);
      setError('Tracking information not found for this AWB.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="hero-container">
      {/* Navbar */}
      <nav className="navbar">
        <img src={logo} alt="SK Logistics Logo" className="navbar-logo" />
        <ul className="nav-links">
          <li><a href="#home">Home</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#services">Services</a></li>
        </ul>
      </nav>

      {/* Hero Section */}
      <div className="hero-banner">
        <div className="hero-overlay">
          <h1 className="slogan">Your Trusted Logistics & Supply Chain Partner</h1>

          <form className="awb-form" onSubmit={handleAWBSubmit}>
            <input
              type="text"
              placeholder="Enter AWB Number"
              value={awbNumber}
              onChange={(e) => setAwbNumber(e.target.value)}
              required
            />
            <button type="submit" disabled={loading}>
              {loading ? 'Loading...' : 'Track AWB'}
            </button>
          </form>

          {error && <p className="error-msg">{error}</p>}
        </div>
      </div>

      {/* Tracking Info List */}
      {/* {trackingData.length > 0 && (
  <div className="tracking-table-wrapper">
    <h3>Tracking History for AWB: <span className="highlight">{awbNumber}</span></h3>
    <table className="tracking-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Status Note</th>
          <th>Location</th>
          <th>Tracking Time</th>
        </tr>
      </thead>
      <tbody>
        {trackingData.map((entry, index) => (
          <tr key={entry.id}>
            <td>{index + 1}</td>
            <td>{entry.status_note}</td>
            <td>{entry.location_name}</td>
            <td>{new Date(entry.tracking_time).toLocaleString()}</td>
          </tr>
        ))}
      </tbody>
    </table>
    <button className="close-btn" onClick={() => setTrackingData([])}>
      Close
    </button>
  </div>
)} */}
{trackingData.length > 0 && (
  <div className="tracking-table-wrapper">
    <h3>Tracking History for AWB: <span className="highlight">{awbNumber}</span></h3>
    <table className="tracking-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Status Note</th>
          <th>Location</th>
          <th>Tracking Time</th>
        </tr>
      </thead>
      <tbody>
        {trackingData.map((entry, index) => (
          <tr key={entry.id}>
            <td>{index + 1}</td>
            <td>
              {entry.status_note}
              {entry.status_note === "Delivered" && entry.proof_image && (
                <div>
                  <img
                    src={`https://bookingapi.sklogisticsgroup.co.in/uploads/${entry.proof_image}`}
                    alt="Proof of Delivery"
                    style={{ marginTop: '8px', maxWidth: '100px', maxHeight: '100px' }}
                  />
                </div>
              )}
            </td>
            <td>{entry.location_name}</td>
            <td>{new Date(entry.tracking_time).toLocaleString()}</td>
          </tr>
        ))}
      </tbody>
    </table>
    <button className="close-btn" onClick={() => setTrackingData([])}>
      Close
    </button>
  </div>
)}

    </div>
  );
}
